var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "captcha"
  }, [!_vm.isSend ? _c("span", {
    staticClass: "send",
    on: {
      click: _vm.sendCode
    }
  }, [_vm._v("发送验证码")]) : _c("span", {
    staticClass: "disabled"
  }, [_vm._v(_vm._s(_vm.secondLeft) + "s后重新发送")])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };